import {
  TableFamiliarBodyVM,
  TableNewFamilySubjectsBodyVM,
} from 'practice/view-models/practice-edit-residence';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCellsFamiliarBody: HeadCell<TableFamiliarBodyVM, keyof TableFamiliarBodyVM>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'birthDate',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'relationship',
    label: 'Parentela',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsNewFamilySubjectsBody: HeadCell<
  TableNewFamilySubjectsBodyVM,
  keyof TableNewFamilySubjectsBodyVM
>[] = [
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'birthDate',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'relationship',
    label: 'Parentela/Legame',
  },
];
